import { useState } from "react";

/**
 * Provides a counter that, when incremented, signals the table to reset pagination to page 1.
 *
 * @returns The current reset count and its setter
 */
export const usePaginationReset = () => {
  const [paginationResetCount, setPaginationResetCount] = useState(0);

  return { paginationResetCount, setPaginationResetCount };
};
